import styled from 'styled-components';
import { rem, tint } from 'polished';
import { GatsbyA } from '@luigiclaudio/ga-baseline-ui/typography';

const ProductItemLink = styled(GatsbyA)`
    background-color: ${({ theme }) => tint(0.025, theme.site.stage.backgroundColor)};
    border-radius: ${({ theme }) => rem(theme.base.borderRadius.md)};
    box-shadow: ${({ theme }) => theme.base.boxShadow.elevationDefault};
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: ${rem(8)};
    width: 100%;
`;

export default ProductItemLink;
